import { action, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import InputField from '../../common/forms/input-field';
import PageFrameSingleForm from '../../common/page-frames/single-form';

import { SignUpProps } from '../../types';

@inject('signUpStore')
@observer
class SignUpMentor extends React.Component<SignUpProps> {
  public render() {
    const store = this.props.signUpStore!;
    
    const formAdditionalInfo = (
        <span>
            Already have an account?&nbsp;
            <a href="/sign-in" className="link has-text-primary">Log in.</a>
        </span>
    );

    return (
      <PageFrameSingleForm title="Mentor Registration" formTitle="Sign up as a Mentor" additionalInfo={formAdditionalInfo}>
        <InputField
            disabled={store.awaitServer}
            helpMessage={store.passwordHelpMessage}
            highlight={store.passwordHighlight}
            layoutClassName="column is-12 is-marginless"
            name="password"
            onBlur={this.handlePasswordBlur}
            onChange={this.handlePasswordChange}
            placeholder="Password"
            type="password"
            value={store.password}
        />

        <InputField
            disabled={store.awaitServer}
            helpMessage={store.confirmHelpMessage}
            highlight={store.confirmHighlight}
            layoutClassName="column is-12 is-marginless"
            name="password"
            onBlur={this.handleConfirmBlur}
            onChange={this.handleConfirmChange}
            placeholder="Confirm password"
            type="password"
            value={store.confirm}
        />

        <div className="column is-12 field is-marginless">
          <button
              className={`button is-primary ${store.awaitServer ? 'is-loading' : ''}`}
              disabled={store.awaitServer}
              onClick={this.handleSubmit}
              type="submit">
            Complete registration
          </button>
          <p id="sign-up-agreement" className="help has-text-grey">By completing registration, you agree to the Terms of Use and Privacy Policy.</p>
        </div>
      </PageFrameSingleForm>
    );
  }


  /**
   * Handles submit action; disables all form controls.
   */
  @action
  private handleSubmit = async () => {
    const store = this.props.signUpStore!;
    store.confirmBlurred = true;
    store.passwordBlurred = true;

    if (store.isReadyForSubmit){
      try {
        await store.signUp();
        // TODO: route user to "user-info/mentor" to further fill up information
        runInAction(() => store.signUpSucceeded = true);
      } catch (error) {
        runInAction(() => {
          store.signUpFailed = true;
          store.awaitServer = false;
        });
      }
    }
  };

  @action
  private handleConfirmChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.signUpStore!.signUpFailed = false;
    this.props.signUpStore!.confirm = event.currentTarget.value;
  }

  @action
  private handleConfirmBlur = () => {
    this.props.signUpStore!.confirmBlurred = true;
  }

  @action
  private handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.signUpStore!.signUpFailed = false;
    this.props.signUpStore!.password = event.currentTarget.value;
  }

  @action
  private handlePasswordBlur = () => {
    this.props.signUpStore!.passwordBlurred = true;
  }
}

export default SignUpMentor;


// WEBPACK FOOTER //
// ./src/pages/sign-up/SignUpMentor.tsx